import React, { useState, useEffect } from 'react';

export default function AnimatedCounter({ targetValue, duration = 1500 }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Ensure we handle incoming string/number inputs
    const finalNumber = parseInt(String(targetValue).replace(/[^0-9]/g, ''), 10);
    
    if (isNaN(finalNumber)) return;

    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      // Easing function
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(easeProgress * finalNumber));

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
    
    // Cleanup frame on unmount
    return () => cancelAnimationFrame(step);
  }, [targetValue, duration]); // <--- This dependency triggers the animation update

  const formatValue = () => {
    const isPlus = String(targetValue).includes('+');
    return `${count.toLocaleString()}${isPlus ? '+' : ''}`;
  };

  return <>{formatValue()}</>;
}